// Where the concrete resin's admin entities are served (see createAdminCrudApi).
export const CONCRETE_RESIN_ADMIN_URL = "/admin/modules/concrete_resin";
